export enum AnchorAlignment {
    Bottom,
    Top,
}

export enum PopupAlignment {
    TopLeft,
    BottomLeft,
    TopRight,
    BottomRight,
}
